module.exports = __webpack_public_path__ + "img/DZ.15fa4e60.svg";